import React from 'react'
import PropTypes from "prop-types";

const PortoBlock = ({ block }) => {
    return(
    <section className="product-info-container" style={{ backgroundColor: block?.componentData?.backgroundColor }}>
        <div className="container">
            <div className="row">
            <div className="col-md-6 col-lg-6">
                <div className="heading">
                <div className="css-lmt9ai">
                    <h4 className="text-transform-none">{block?.componentData?.headTitle}</h4>
                </div>
                <div className="css-t09yf2">
                    <h2 className="text-transform-none">{block?.componentData?.subTitle}</h2>
                </div>
                <div className="css-t09yf2">
                    <div className="d-flex">
                    <h5 className="d-inline-block mb-0">
                        <span>{block?.componentData?.priceTitle}</span>
                        <b className="coupon-sale-text text-white bg-secondary align-middle">
                        <sup>$</sup>
                        <em className="align-text-top">{block?.componentData?.price}</em>
                        <sup>{block?.componentData?.fractions}</sup>
                        </b>
                    </h5>
                    </div>
                </div>
                </div>
                <ul className="product-info-content">
                    {block?.componentData?.leftPanel?.map((product, index) => {
                        return (
                                        <div key={index} className="css-2btoct">
                                        <div className="product-info-item">
                                        <div className="product-default media-with-lazy ">
                                            <figure className="d-none">
                                            <a href={product?.link}>
                                                <div className="lazy-overlay" />
                                                <span className=" lazy-load-image-background black and white" style={{"display":"inline-block","height":"auto","width":"100%"}}>
                                                <span className style={{"display":"inline-block","width":"100%","height":"auto"}} />
                                                </span>
                                                <span className="product-image-hover lazy-load-image-background black and white" style={{"display":"inline-block"}}>
                                                <span className style={{"display":"inline-block"}} />
                                                </span>
                                            </a>
                                            </figure>
                                            <div className="product-details d-flex align-items-center flex-wrap justify-content-start">
                                            <h3 className="product-title">
                                                <a href={product?.link}>{product?.name}</a>
                                            </h3>
                                            <div className="price-box">
                                                <span className="old-price">${product?.oldPrice}</span>
                                                <span className="product-price">${product?.productPrice}</span>
                                            </div>
                                             <a className="btn-icon btn-add-cart" href={product?.link} >Select Option</a>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    )
                    })}
                </ul>
            </div>
            <div className="col-12 col-md-6 col-lg-4 position-relative mt-auto" style={{"zIndex":"3"}}>
                <div className="css-1acuaao">
                <div className="product-info-image media-with-lazy">
                    <figure className="mb-0">
                    <span className=" lazy-load-image-background black and white lazy-load-image-loaded" style={{"display":"inline-block","height":"auto","width":"100%"}}>
                        <img alt="Product" src={block?.componentData?.backgroundImage} width="100%" height="auto" />
                    </span>
                    </figure>
                    {block?.componentData?.dotProducts?.map((product, index) => {
                        return(
                            <div key={index} className="product-popup-dot" style={{ left: product?.left, top: product?.top }}>
                            <a href="#">
                                <i className="fa fa-circle" />
                            </a>
                            <div className="product-popup-wrap">
                                <div className="product-default media-with-lazy inner-quickview inner-icon">
                                <figure>
                                    <a href={product?.link}>
                                    <div className="lazy-overlay" />
                                    <span className=" lazy-load-image-background black and white lazy-load-image-loaded" style={{"display":"inline-block","height":"auto","width":"100%"}}>
                                        <img alt="product" src={product?.img} width="100%" height="auto" />
                                    </span>
                                    </a>
                                </figure>
                                <div className="product-details">
                                    <div className="category-wrap">
                                    </div>
                                    <h3 className="product-title">
                                    <a href={product?.link}>{product?.name}</a>
                                    </h3>
                                    <div className="price-box">
                                    <span className="old-price">${product?.oldPrice}</span>
                                    <span className="product-price">${product?.productPrice}</span>
                                    </div>
                                             <a className="btn-icon btn-add-cart d-flex align-items-center justify-content-center" href={product?.link}>
                                             <i className="fa fa-arrow-right pt-1" />
                                             <span>SELECT OPTIONS</span>
                                             </a>
                                </div>
                                </div>
                            </div>
                        </div>
                        )
                    })}
                </div>
                </div>
            </div>
            <div className="col-12 col-sm-8 col-md-6 col-lg-2 d-flex align-items-center">
                <div className="btn-group flex-column mt-0 mt-md-3 mt-lg-0">
                <div className="btn btn-dark btn-shop m-b-3 css-jowhdy" style={{ marginBottom: '5px', borderRadius: '0px' }}>
                    <a className="text-white" href={block?.componentData?.firstButtonLink}>{block?.componentData?.firstButtonName}</a>
                </div>
                <div className="btn btn-dark btn-shop css-jowhdy" style={{ borderRadius: '0px' }}>
                    <a className="text-white" href={block?.componentData?.secondButtonLink}>{block?.componentData?.secondButtonName}</a>
                </div>
                </div>
            </div>
            </div>
        </div>
</section>
    )
}

PortoBlock.propTypes = {
    bgClass: PropTypes.string,
    spaceBottomClass: PropTypes.string,
    spaceTopClass: PropTypes.string
  };

export default PortoBlock;